import React from 'react';
import { faFileExcel } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  show: boolean;
  onClose(): void;
  onDownloadFile(): void;
};

const ExportModal: React.FC<Props> = ({ show, onClose, onDownloadFile }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (show) {
      downloadXls();
    }
  }, [show]);

  const downloadXls = () => {
    if (!isLoading) {
      setIsLoading(true);
      onDownloadFile();
      setIsLoading(false);
    }
  };

  return (
    <Modal
      visible={show}
      title={'Downloading File'}
      closable={false}
      footer={[
        <Button
          type='link'
          key="close"
          onClick={() => {
            if (isLoading) {
              Modal.confirm({
                content:
                  'The download will still continue when this window is closed',
                async onOk() {
                  onClose();
                },
              });
            } else onClose();
          }}
        >
          Close
        </Button>,
      ]}
      centered
      width={700}
    >
      <div style={{ textAlign: 'center' }}>
        <FontAwesomeIcon icon={faFileExcel as IconProp} size='6x' />
      </div>
      <br/>
      {isLoading && (
        <div style={{ textAlign: 'center' }}>
          <h3>Your Download Will Begin Shortly</h3>
          <p style={{ textAlign: 'center' }}>
            <span>
              Larger exports may take up to a few minutes to generate, thank you
              for your patience.
            </span>
          </p>
        </div>
      )}
      {!isLoading && (
        <div style={{ textAlign: 'center' }}>
          <h3>Your Download Has Started</h3>
        </div>
      )}
    </Modal>
  );
};

export default ExportModal;
